import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { SubscriptionComponentConfig, subscriptionComponentConfigInput } from "panels/subscriptions/component/SubscriptionComponentConfig";

@Form({title: "User Subscriptions List Config"})
export class Config {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine Controls"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize?: number;

	@Input({type: subscriptionComponentConfigInput, title: "Subscription Display Settings"})
	public subscriptionComponent?: SubscriptionComponentConfig;
}



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/Config.ts